import React from 'react';
import { Lock } from '@gjensidige/builders-icons';
import { Nav } from '@gjensidige/core-navigation';

import { useIsLoggedIn } from '../hooks/useIsLoggedIn';
import { ROUTE } from '../utils/routes';
import { clearCache } from '../utils/utils';

export const NavUser = () => {
  const isMobile = React.useContext(Nav.isMobile);
  const { data: isLoggedIn } = useIsLoggedIn();

  return (
    <>
      {!isMobile && (
        <>
          <style>{`
    nav[data-mobile="false"] .userDrop {
    background: var(--nav-background-dark);
    border-radius: 0 0 8px 8px;
    color: #fff;
    flex-flow: column;
    position: absolute;
    right: var(--nav-space-pad);
    width: 240px;
  }
`}</style>
          {/*
            <Nav.User
              label={'Oversigt'}
              classNameExpand="userDrop"
              icon={IS_BEDRIFT ? <BuildingCorporate height={21} width={21} /> : <House height={21} width={21} />}
              className={styles.userItem}
              {...(isMobile && { href: 'add link here' })}
            >
              {!isMobile && (
                <>
                  {hasBedriftAndAccess() &&
                    (showByttBrukerLink() ? (
                      <Nav.Item icon={<SwitchUser />} label="Bytt bruker" href={'add link here'} />
                    ) : (
                      <ul className={styles.bedriftList}>
                        {NavDropdownContent().map((bedrift) => (
                          <Nav.Item key={bedrift?.partref} icon={bedrift?.icon} href={bedrift?.href}>
                            {bedrift?.label}
                          </Nav.Item>
                        ))}
                        <div className={styles.separator} />
                      </ul>
                    ))}
                  <Nav.Item icon={<Person />} label="Profil" href={'/kunde/privat/min-side/mine-kontaktoplysninger'} />
                  {IS_BEDRIFT && <Nav.Item icon={<Lock />} label="Gå til Julies coffee shop" href={'add link here'} />}
                  <Nav.Item icon={<Lock />} label="Log ud" href={'add link here'} />
                </>
              )}
            </Nav.User>
            */}

          {isLoggedIn ? (
            <Nav.Actions>
              <Nav.Item icon={<Lock />} label="Log ud" href={ROUTE.LOGOUT} onClick={clearCache} />
            </Nav.Actions>
          ) : (
            <Nav.Actions>
              <Nav.Item icon={<Lock />} label="Log ind" href={'/login'} />
            </Nav.Actions>
          )}
        </>
      )}
    </>
  );
};
